export const _scheme = /[a-zA-Z][a-zA-Z0-9+.-]{1,31}/
